export const CONFIGURE_OBJECT_CHOOSER = 'CONFIGURE_OBJECT_CHOOSER'
